import { Bubble, MeetingsIcon, QuestionCircleLine, SessionChatLine } from '@bizzabo/design-system';
import { BuildInAppToolId } from '../types/appTools';

export const AppToolbarIconConfig = {
    [BuildInAppToolId.Messages]: <Bubble />,
    [BuildInAppToolId.SessionChats]: <SessionChatLine />,
    [BuildInAppToolId.Meetings]: <MeetingsIcon />,
    [BuildInAppToolId.SupportChat]: <QuestionCircleLine width={20} height={20} />,
};
